import { render, staticRenderFns } from "./CGrid.vue?vue&type=template&id=8cd7be18&scoped=true&"
import script from "./CGrid.vue?vue&type=script&lang=js&"
export * from "./CGrid.vue?vue&type=script&lang=js&"
import style0 from "./CGrid.vue?vue&type=style&index=0&id=8cd7be18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cd7be18",
  null
  
)

export default component.exports